import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { Button, Divider, Stack, Typography } from "@mui/material"

import { useForm } from '../../../hooks';
import { PrincipalLayouts } from '../../../layouts';
import { Field } from '../miProfile/Field';
import { DateInput } from '../DateInput';
import { addEvent } from '../../helpers/event';


export const AddEvent = () => {

  const navigate = useNavigate();
  const [isWaiting, setIsWaiting] = useState(false);
  const { t } = useTranslation('global');
  const [formValues, handleInputChange, reset] = useForm({ name: '', date: '', url: '' });

  const { name, date, url } = formValues;

  const handleConfirm = async (e) => {
    e.preventDefault();
    setIsWaiting(true)
    addEvent(formValues, t('addevent.succesMsg'), t('addevent.errorMsg'), t('error.errorNameDup'), navigate)
    setIsWaiting(false)
    reset()
  }

  const handleCancel = () => {
    reset();
    navigate('/events')
  }

  return (
    <PrincipalLayouts>
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <Typography color='primary' variant='h5'>{t('addevent.titlePage')}</Typography>
      </Stack>
      <Divider sx={{ marginTop: 2, marginBottom: 3 }} />

      <form onSubmit={handleConfirm}>
        <Stack minHeight='calc(100vh - 290px)' gap={2}>

          <Stack direction='row' width='100%' gap={2}>
            <Field translation='addevent' name={name} title='name' handleInputChange={handleInputChange} required={true} />
            <DateInput name={date} title='date' handleInputChange={handleInputChange} required={true} hasMin={true}/>
          </Stack>

          <Field translation='addevent' name={url} title='url' handleInputChange={handleInputChange} required={true} />

        </Stack>

        <Stack direction='row' justifyContent='end' gap={2} marginTop={3}>
          <Button sx={{ width: '140px' }} color='secondary' onClick={handleCancel} variant="outlined">{t('myprofile.cancelButton')}</Button>
          <Button disabled={isWaiting} sx={{ width: '140px' }} type='submit' variant="contained">{t('myprofile.confirmButton')}</Button>
        </Stack>
      </form>

    </PrincipalLayouts>
  )
}